<!-- 暂无数据 -->
<template>
  <div class="no-info">
    <div>
      <div class="img mb15">
        <img src="./../../../assets/img/copy_file.png" />
      </div>
      <div class="f14">
        {{txt}}
      </div>
      <!-- <div class="mt30 f15">
        <div>联系客服</div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'no-info',
  props: {
    txt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}
</script>
<style lang='scss' scoped>
.no-info {
  margin: 0 10px;
  > div {
    background: #fff;
    width: 100%;
    height: 260px;
    border-radius: 10px;
    padding-top:60px;
    // box-sizing: border-box;
    .img {
      width: 100%;
      height: 20 0px;
      @include center();
    }
    img {
      width: 160px;
      height: 140px;
    }
    div:nth-child(2) {
      padding: 0 40px;
      @include center();
      text-align: center;
    }
    div:nth-child(3) {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      div {
        width: 315px;
        height: 40px;
        border: 1px solid var(--APP_theme_color);
        color: var(--APP_theme_color);
        @include center();
        border-radius: 20px;
      }
    }
  }
}
</style>
